import express, { Router } from 'express';
import { metaLeadsWebhook, metaVerify } from './meta.controller';

const router: Router = express.Router();

// Verification callback for Meta (Facebook) Webhooks and verify
router
  .route('/verify')
  .get(metaVerify)
  .post(metaLeadsWebhook); // Lead notifications from Meta (Facebook Lead Ads)

export default router;
